









































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'GestionFluxBuilders',  
})
export default class GestionFluxBuilders extends Vue {
  private loading = false
  private showError = false 
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }
  

  private get fluxBuildersList() {
    return this.$store.myGetters.fluxBuildersList
  }
  
  private get search(){
    return this.$store.myGetters.searchFluxBuilder
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_FLUXBUILDER(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortFluxBuilderDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_FLUXBUILDER_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortFluxBuilderBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_FLUXBUILDER_BY(value)
  }

  private get headers(){
    return [
      { text: 'ID', value: 'id', width:80 },            
      { text: 'FluxBuilder', value: 'libelle' },
      { text: 'Key', value: 'bldKey' }
    ]
  } 

  created() {
    this.loading = true
    this.$store.myActions.CATALOGUE_FLUXBUILDER_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyFluxBuilders',params:{bldId:item.id}})
  } 

  addFluxBuilder(){
    //@ts-ignore
    this.$router.push({name:'ModifyFluxBuilders',params:{bldId:0}})
  } 
 
}
